import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Stack, Typography } from "@mui/material";
import TbsPageLayout from "../shared/TbsPageLayout";
import { NAV_TEXTS } from "../shared/constants";

// The 404 for the management app (`TBS-78`).
//
// **The storefront's `NotFoundPage` cannot serve here**, and not merely because it looks like the
// shop: it renders `PageLayout` → `HeaderBar` → `CartButton`, which reads the cart drawer's context.
// A `TBS_ONLY` build does not mount `CartDrawerProvider`, so the shop's 404 page would itself throw
// — a mistyped URL answered by a blank screen and a console error.
//
// It carries the app's own header, so a wrong address leaves you somewhere you can navigate out of.

export const TbsNotFoundPage: React.FC = () => (
  <TbsPageLayout>
    <Stack spacing={2} alignItems="flex-start">
      <Typography variant="h5" component="h1">
        {NAV_TEXTS.notFound}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {NAV_TEXTS.notFoundHelp}
      </Typography>
      <Button component={RouterLink} to="/gestion" variant="contained">
        {NAV_TEXTS.backHome}
      </Button>
    </Stack>
  </TbsPageLayout>
);

export default TbsNotFoundPage;
